import { useTranslation } from 'react-i18next';

import SectionTitle from '../Shared/SectionTitle/SecctionTitle';
import HowItWorkItem from './HowItWorkItem/HowItWorkItem';
import classes from './HowItWork.module.css';
import phoneImage from '../../assets/images/how-it-work.webp';

const HowItWork = (props) => {
    const {t} = useTranslation();

    return (
        <section id="how-it-work" className={classes.HowItWork}>
            <div className="container">
                <SectionTitle title={t('howItWork.title')} />
                <div className="row">
                    <div className="col-8">
                        <ul className={classes.HowItWorkList}>
                            <HowItWorkItem
                                number="1"
                                title={t('howItWork.step1.title')}
                                description={t('howItWork.step1.description')} 
                                border={true}/>
                            <HowItWorkItem
                                number="2"
                                title={t('howItWork.step2.title')}
                                description={t('howItWork.step2.description')}
                                border={true}/>
                            <HowItWorkItem
                                number="3"
                                title={t('howItWork.step3.title')}
                                description={t('howItWork.step3.description')}
                                border={true}/>
                            <HowItWorkItem
                                number="4"
                                title={t('howItWork.step4.title')}
                                description={t('howItWork.step4.description')}
                                border={false}/>
                        </ul>
                    </div>
                    <div className="col-4" data-aos="fade-up">
                        <img src={phoneImage} alt="Red Taxi" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HowItWork;